<template>
  <div>
    <Form @submit="savePayInfo">
      <Divider content-position="left">支付参数</Divider>
      <Field
        label="应付金额"
        v-model="orderData.money"
        label-width="4.4em"
        type="number"
      >
        <template #extra> 元 </template>
      </Field>
      <Field
        label="支付ID"
        v-model="orderData.payId"
        readonly
        label-width="4.4em"
        ><template #button>
          <Button size="small" type="default" round>复制</Button>
        </template></Field
      >
      <Field>
        <template #input>
          <Button
            size="small"
            type="success"
            color="#292827"
            round
            block
            native-type="submit"
            >保存支付参数</Button
          >
        </template>
      </Field>
    </Form>
  </div>
</template>
<script setup>
import { Button, Field, Divider, Form, Notify } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData, saveOrder } = useOrder();
// 密码
let AuthorizationCode = sessionStorage.getItem("AuthorizationCode");
const savePayInfo = () => {
  const { payId, money } = orderData.value;
  saveOrder({ payId, money }, AuthorizationCode)
    .then((res) => {
      Notify({ type: "success", message: res });
    })
    .catch((res) => {
      Notify({ type: "warning", message: res });
    });
};
</script>
